import { Board } from "@/types/board";
import { Activity, CheckCircle2, Clock } from "lucide-react";

interface StatsSectionProps {
    boards: Board[];
}

export const StatsSection = ({ boards }: StatsSectionProps) => {
    const totalBoards = boards.length;
    const totalCards = boards.reduce((acc, board) =>
        acc + (board.columns?.reduce((sum, col) => sum + (col.cards?.length || 0), 0) || 0), 0);

    const completedCards = boards.reduce((acc, board) =>
        acc + (board.columns?.reduce((sum, col) =>
            sum + (col.title.toLowerCase().includes('done') || col.title.toLowerCase().includes('complete') ? (col.cards?.length || 0) : 0), 0) || 0), 0);

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="group relative overflow-hidden rounded-xl bg-white/[0.02] p-6 hover:bg-white/[0.04] transition-all duration-300 border border-white/[0.05]">
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/10 via-transparent to-transparent" />
                <div className="relative flex items-center justify-between">
                    <div>
                        <p className="text-sm text-indigo-300/80">Total Projects</p>
                        <p className="text-2xl font-bold text-white mt-1">{totalBoards}</p>
                    </div>
                    <Activity className="h-8 w-8 text-indigo-400" />
                </div>
            </div>

            <div className="group relative overflow-hidden rounded-xl bg-white/[0.02] p-6 hover:bg-white/[0.04] transition-all duration-300 border border-white/[0.05]">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 via-transparent to-transparent" />
                <div className="relative flex items-center justify-between">
                    <div>
                        <p className="text-sm text-purple-300/80">Active Tasks</p>
                        <p className="text-2xl font-bold text-white mt-1">{totalCards - completedCards}</p>
                    </div>
                    <Clock className="h-8 w-8 text-purple-400" />
                </div>
            </div>

            <div className="group relative overflow-hidden rounded-xl bg-white/[0.02] p-6 hover:bg-white/[0.04] transition-all duration-300 border border-white/[0.05]">
                <div className="absolute inset-0 bg-gradient-to-br from-pink-500/10 via-transparent to-transparent" />
                <div className="relative flex items-center justify-between">
                    <div>
                        <p className="text-sm text-pink-300/80">Completed</p>
                        <p className="text-2xl font-bold text-white mt-1">{completedCards}</p>
                    </div>
                    <CheckCircle2 className="h-8 w-8 text-pink-400" />
                </div>
            </div>
        </div>
    );
};
